module.exports = __webpack_public_path__ + "static/media/minhaz.b1e8dd2b.png";